import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import { Ionicons as Icon } from '@expo/vector-icons';
import { Colors } from '../constants/colors';

var TYPE_COLORS = {
  medication: Colors.medication,
  selfCare: Colors.selfCare,
  wellness: Colors.wellness,
};

export default function TaskCard({ task, onToggle }) {
  var barColor = TYPE_COLORS[task.type] || Colors.textLight;

  return (
    <TouchableOpacity onPress={onToggle} activeOpacity={0.7} style={[s.card, task.done && s.cardDone]}>
      <View style={[s.colorBar, { backgroundColor: barColor }]} />
      <View style={[s.checkCircle, task.done && s.checkCircleDone]}>
        {task.done && <Icon name="checkmark" size={14} color="#fff" />}
      </View>
      <Text style={[s.name, task.done && s.nameDone]}>{task.name}</Text>
      <Icon name="chevron-forward" size={18} color={Colors.primary} />
    </TouchableOpacity>
  );
}

var s = StyleSheet.create({
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
    backgroundColor: Colors.card,
    borderRadius: 14,
    paddingVertical: 14,
    paddingHorizontal: 16,
    marginHorizontal: 20,
    marginBottom: 8,
    borderWidth: 1,
    borderColor: 'transparent',
  },
  cardDone: {
    backgroundColor: Colors.greenLight,
    borderColor: 'rgba(76,175,80,0.3)',
  },
  colorBar: {
    width: 5,
    height: 30,
    borderRadius: 3,
  },
  checkCircle: {
    width: 22,
    height: 22,
    borderRadius: 11,
    borderWidth: 1.5,
    borderColor: Colors.textLight,
    alignItems: 'center',
    justifyContent: 'center',
  },
  checkCircleDone: {
    backgroundColor: Colors.green,
    borderColor: Colors.green,
  },
  name: {
    flex: 1,
    fontSize: 15,
    fontWeight: '500',
    color: Colors.textDark,
  },
  nameDone: {
    textDecorationLine: 'line-through',
    opacity: 0.7,
  },
});
